import { CheckboxUI } from "src/pages/DashboardPage/acadia/components/Filters/CheckLists";
import { CheckBoxListItem } from "src/types/main";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import { twMerge } from "tailwind-merge";
import Loading from "../Loading";

export function TGCheckList({
  list,
  readOnly = false,
  items,
  onChecked,
  loading = false,
}: {
  list: CheckBoxListItem[];
  readOnly?: boolean;
  items: CheckBoxListItem[];
  onChecked: (item: CheckBoxListItem) => void;
  loading?: boolean;
}) {
  function handleChecked(item: CheckBoxListItem) {
    onChecked(item);
  }

  // Selected items that are not present in the current list are prepended so
  // they remain visible (and checked) even when the list is rebuilt/filtered.
  const selectedNotInList = items.filter(
    (selectedItem) => !list.some((listItem) => listItem.id === selectedItem.id),
  );
  const displayList = [...selectedNotInList, ...list];

  return (
    <FlexRow>
      <FlexCol
        className={twMerge(
          "gap-y-[15px] grow max-h-[350px] overflow-y-auto scrollbar scrollbar-w-2 scrollbar-thumb-rounded-lg scrollbar-thumb-[#D1D5DB]",
        )}
      >
        {displayList.map((item, i) => {
          return (
            <CheckboxUI
              key={item.id}
              item={item}
              index={i}
              onChecked={handleChecked}
              isCheck={items.some((t) => t.id === item.id)}
              disabled={readOnly}
            />
          );
        })}
        {loading ? <Loading /> : null}
      </FlexCol>
    </FlexRow>
  );
}
